"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _get = _interopRequireDefault(require("lodash/get"));

var _Language = _interopRequireDefault(require("@material-ui/icons/Language"));

var _MailOutline = _interopRequireDefault(require("@material-ui/icons/MailOutline"));

var _PhoneOutlined = _interopRequireDefault(require("@material-ui/icons/PhoneOutlined"));

var _AddCircle = _interopRequireDefault(require("@material-ui/icons/AddCircle"));

var _RemoveCircle = _interopRequireDefault(require("@material-ui/icons/RemoveCircle"));

var _Avatar = _interopRequireDefault(require("../../screens/Settings/components/fields/Avatar"));

var _InfoView = require("../ContactDetail/InfoView");

var _Button = _interopRequireDefault(require("../Button"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

require("./index.css");

function ArraySection(_ref) {
  var _ref$enableAdd = _ref.enableAdd,
      enableAdd = _ref$enableAdd === void 0 ? true : _ref$enableAdd,
      name = _ref.name,
      defaultValues = _ref.defaultValues,
      title = _ref.title,
      formikProps = _ref.formikProps,
      _render = _ref.render;
  return /*#__PURE__*/_react["default"].createElement(_formik.FieldArray, {
    name: name,
    render: function render(arrayHelpers) {
      var data = (0, _get["default"])(formikProps.values, name, []);

      if (data.length < 1) {
        arrayHelpers.push(defaultValues);
      }

      return /*#__PURE__*/_react["default"].createElement(_InfoView.InfoSection, {
        title: /*#__PURE__*/_react["default"].createElement("div", {
          className: "flex items-center justify-between"
        }, title, enableAdd && /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
          title: "Add"
        }, /*#__PURE__*/_react["default"].createElement(_AddCircle["default"], {
          fontSize: "small",
          className: "cursor-pointer text-primary",
          onClick: function onClick(e) {
            return arrayHelpers.push(defaultValues);
          }
        })))
      }, data.map(function (values, index) {
        return _render({
          index: index,
          arrayHelpers: arrayHelpers,
          fieldName: "".concat(name, ".").concat(index)
        });
      }));
    }
  });
}

var initialContact = {
  avatar: '',
  firstName: '',
  lastName: '',
  jobTitle: '',
  company: '',
  emails: [],
  phones: [],
  addresses: [],
  websites: []
};

var ContactForm = function ContactForm(_ref2) {
  var enableToSubmit = _ref2.enableToSubmit,
      renderAvatar = _ref2.renderAvatar,
      onSubmit = _ref2.onSubmit,
      onClose = _ref2.onClose,
      _ref2$contact = _ref2.contact,
      contact = _ref2$contact === void 0 ? initialContact : _ref2$contact;
  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: contact,
    onSubmit: onSubmit,
    render: function render(formikProps) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "Contact-form overflow-y-auto pt-8 flex-1"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "text flex items-center px-6 pb-10 bg-card"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex pl-3 pr-6"
      }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
        name: "avatar",
        avatar: renderAvatar({
          src: formikProps.values.avatar,
          alt: [formikProps.values.firstName, formikProps.values.lastName].join(' ')
        })
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex flex-col w-full"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex"
      }, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
        autoFocus: true,
        name: "firstName",
        placeholder: "First Name",
        className: "flex-1 mr-2"
      }), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
        name: "lastName",
        placeholder: "Last Name",
        className: "flex-1 ml-2"
      })), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
        name: "jobTitle",
        placeholder: "Job Title"
      }), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
        name: "company",
        placeholder: "Company Name"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "text px-6 py-4 shadow-inner bg-card"
      }, /*#__PURE__*/_react["default"].createElement(ArraySection, {
        enableAdd: false,
        name: "emails",
        title: "Email",
        formikProps: formikProps,
        defaultValues: {
          email: ''
        },
        render: function render(_ref3) {
          var index = _ref3.index,
              fieldName = _ref3.fieldName,
              arrayHelpers = _ref3.arrayHelpers;
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: "".concat(fieldName, ".email"),
            className: "flex items-center"
          }, /*#__PURE__*/_react["default"].createElement(_MailOutline["default"], {
            fontSize: "small",
            className: "!text-sm text-gray-light mx-4"
          }), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
            disabled: true,
            name: "".concat(fieldName, ".email"),
            className: "flex-1 border-none",
            placeholder: "Email Address"
          }));
        }
      }), /*#__PURE__*/_react["default"].createElement(ArraySection, {
        name: "phones",
        title: "Phone",
        formikProps: formikProps,
        defaultValues: {
          phone: ''
        },
        render: function render(_ref4) {
          var index = _ref4.index,
              fieldName = _ref4.fieldName,
              arrayHelpers = _ref4.arrayHelpers;
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: "".concat(fieldName, ".phone"),
            className: "flex items-center"
          }, /*#__PURE__*/_react["default"].createElement(_PhoneOutlined["default"], {
            fontSize: "small",
            className: "!text-sm text-gray-light mx-4"
          }), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
            name: "".concat(fieldName, ".phone"),
            className: "flex-1",
            placeholder: "Phone Number"
          }), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
            title: "Remove"
          }, /*#__PURE__*/_react["default"].createElement(_RemoveCircle["default"], {
            fontSize: "small",
            className: "cursor-pointer text-gray-light",
            onClick: function onClick() {
              return arrayHelpers.remove(index);
            }
          })));
        }
      }), /*#__PURE__*/_react["default"].createElement(ArraySection, {
        name: "websites",
        title: "Web Links",
        formikProps: formikProps,
        defaultValues: {
          phone: ''
        },
        render: function render(_ref5) {
          var index = _ref5.index,
              fieldName = _ref5.fieldName,
              arrayHelpers = _ref5.arrayHelpers;
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: "".concat(fieldName, ".website"),
            className: "flex items-center"
          }, /*#__PURE__*/_react["default"].createElement(_Language["default"], {
            fontSize: "small",
            className: "!text-sm text-gray-light mx-4"
          }), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
            name: "".concat(fieldName, ".website"),
            className: "flex-1",
            placeholder: "www.example.com"
          }), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
            title: "Remove"
          }, /*#__PURE__*/_react["default"].createElement(_RemoveCircle["default"], {
            fontSize: "small",
            className: "text-gray-light cursor-pointer",
            onClick: function onClick() {
              return arrayHelpers.remove(index);
            }
          })));
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "Contact-form-mask w-full sticky h-8"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex flex-none flex-row justify-start items-center flex-nowrap h-18"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "px-3 pb-3"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        color: 'secondary',
        onClick: onClose,
        className: 'w-40'
      }, "Cancel")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "px-3 pb-3"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        disabled: !formikProps.dirty || !enableToSubmit,
        onClick: formikProps.handleSubmit,
        className: 'w-40'
      }, "Save"))));
    }
  });
};

var _default = ContactForm;
exports["default"] = _default;
//# sourceMappingURL=index.js.map